import { Briefcase, Building2, LineChart, Users } from "lucide-react";

const personas = [
  { icon: Briefcase, role: "CEOs & Founders", desc: "Wanting a defensible AI thesis before allocating capital." },
  { icon: LineChart, role: "CFOs & COOs", desc: "Looking to quantify ROI before approving AI initiatives." },
  { icon: Building2, role: "Heads of Strategy", desc: "Building the AI roadmap that will face the board." },
  { icon: Users, role: "Transformation leads", desc: "Needing a structured starting point teams can rally behind." },
];

const WhoFor = () => {
  return (
    <section className="bg-secondary/40 py-12 lg:py-14">
      <div className="container-tight">
        <div className="max-w-3xl">
          <span className="eyebrow">Who it's for</span>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
            Built for leadership teams making real AI decisions.
          </h2>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {personas.map(({ icon: Icon, role, desc }) => (
            <div key={role} className="rounded-2xl border border-border bg-card p-6 shadow-soft">
              <Icon className="h-5 w-5 text-signal" strokeWidth={1.75} />
              <h3 className="mt-4 text-base font-semibold text-foreground">{role}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{desc}</p>
            </div>
          ))}
        </div>

        <p className="mt-10 max-w-2xl text-base text-muted-foreground">
          If you're trying to figure out where to begin, <span className="font-medium text-foreground">this is designed to be that starting point</span>.
        </p>
      </div>
    </section>
  );
};

export default WhoFor;
